import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import { StyledButton } from 'components/shared'

export default function Donate() {
  return (
    <div className="w-full relative py-12 md:py-24 z-0 ">
      <div className="relative z-10 text-center space-y-5 w-11/12 mx-auto">
        <h5 className="text-white font-bold text-3xl uppercase md:text-[38px]">
          Donate
        </h5>
        <p className="p-0 text-white font-medium md:text-[20px]">
          MAKE A TAX DEDUCTIBLE CONTRIBUTION
        </p>
        <StyledButton
          text="Make A Donation"
          className="text-black"
          external
          href="https://healingtree.app.neoncrm.com/forms/dorothy-dandridge-the-musical"
          target="_blank"
          rel="noreferrer"
        />
      </div>
      <div className="absolute inset-0 z-0 w-full h-full">
        <StaticImage
          src="../../../images/backgrounds/donate-background.png"
          alt=""
          className="w-full h-full"
        />
      </div>
    </div>
  )
}
